import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { JobBrandingModel } from '../job-service/service-models/job-branding-model';

@Component({
  selector: 'app-continue-saved-application',
  templateUrl: './continue-saved-application.component.html',
  styleUrls: ['./continue-saved-application.component.scss']
})
export class ContinueSavedApplicationComponent implements OnInit {

  private readonly subscription = new Subscription();

  constructor(private readonly route: ActivatedRoute, private readonly router: Router) { }

  ngOnInit() {
    this.subscription.add(
      this.subscription.add(this.route.queryParams.subscribe(
        params => {
          const url = decodeURI(params['url']);
          localStorage.setItem('applicationId', params['id']);
  
          const completeApplicationPartRequestId = params['partId'];
          if (completeApplicationPartRequestId) {
            sessionStorage.setItem('completeApplicationPartRequestId', completeApplicationPartRequestId);
          }

          this.subscription.add(
            this.route.data.subscribe(
              (data: { model: JobBrandingModel }) => {
                // The url needs to be eagerly updated in order for the
                // ThemeResolver to be able to get the instance identifier from the url
                this.router.urlUpdateStrategy = 'eager';
                const instanceIdentifier = data.model.instance ? data.model.instance.identifier : '';
                const subBrandIdentifier = data.model.subBrand ? data.model.subBrand.identifier : '';
                this.router.navigateByUrl(
                  subBrandIdentifier ?
                    `/${instanceIdentifier}/${subBrandIdentifier}/${url}` :
                    `/${instanceIdentifier}/${url}`
                )
                .then(x => this.router.urlUpdateStrategy = 'deferred');
              })
          );
        }))
      );
  }

}
